import { isArray } from 'lodash-es';

import { BackendResponseModel, ErrorModel } from '../../models';
import { BaseErrorHandler } from './base-error.handler';

export class BusinessLogicExceptionHandler extends BaseErrorHandler {
  handle(): BackendResponseModel {
    const result = new BackendResponseModel();

    result.isShowNotification = true;
    this.httpResponseError?.errors.forEach((error) => {
      result.addError({
        errorCode: error.errorCode,
        errorDescription: error.message,
        errorDetails: '',
        memberName: error.memberName,
      });
    });

    return result;
  }

  canHandle(): boolean {
    try {
      const errorsIsArray = isArray(this.httpResponseError?.errors);
      return (
        errorsIsArray &&
        !this.httpResponseError?.isException &&
        !!this.httpResponseError?.errors[0]?.message &&
        !!this.httpResponseError?.errors[0]?.errorCode
      );
    } catch {}
    return false;
  }
}
